/* eslint-disable no-useless-computed-key */
import './Card.css';
import {
    IconBriefcase,
    IconChartDots,
    IconChartHistogram,
    IconContract,
    IconFile,
    IconFilePencil,
    IconFilters,
    IconMoneybag,
    IconPlus,
    IconStethoscope,
    IconUsersGroup,
    IconCertificate,
    IconAddressBook,
    IconFileDollar
} from '@tabler/icons-react';

export const iconMap = {
    ['Documentação']: <IconFile fontSize={30} />,
    ['Contratualização']: <IconFilePencil fontSize={30} />,
    ['Organização']: <IconFilters fontSize={30} />,
    'Recursos Humanos': <IconUsersGroup fontSize={30} />,
    Demonstrativos: <IconChartDots fontSize={30} />,
    ['Finanças']: <IconMoneybag fontSize={30} />,
    'Editais e Contratos': <IconContract fontSize={30} />,
    Indicadores: <IconChartHistogram fontSize={30} />,
    'Escala Médica': <IconStethoscope fontSize={30} />,
    'Processos Seletivos': <IconBriefcase fontSize={30} />,
    'Qualificação': <IconCertificate fontSize={30} />,
    'Descrição de Cargos': <IconAddressBook fontSize={40} />,
    'Emenda Parlamentar': <IconFileDollar fontSize={30} />
};

export const Card = ({ title, description, onClick, page }) => {
    const selectedIcon = iconMap[title] ?? <IconPlus fontSize={20} />;

    return (
        <div
            className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 d-flex align-items-stretch pb-3"
            onClick={onClick} >
            <div className="home_card_container_pdc_home"
                style={{ backgroundImage: `url('/image/${page}.png')` }} >
                <div className="home_card_textbox">
                    <h4 className="home_card_title_pdc_home">{selectedIcon}{title}</h4>
                    <p className="home_card_description_pdc_home">{description}</p>
                </div>
            </div>
        </div>
    );
};
